import { emptyAction } from '../../actions';
import { PublicDeviceAction, DeviceActionType } from '../../actions/actions';
import { CurrentSensorValuesType } from '../../models/commons';

export interface PublicDeviceSensorDataStore {
    loading: boolean;
    error: boolean;
    errorMessage: string;
    sensorData: Array<CurrentSensorValuesType>;
    timeStamp: number;
}

const initialStore: PublicDeviceSensorDataStore = {
    loading: false,
    error: false,
    errorMessage: '',
    sensorData: [],
    timeStamp: 0,
};

const publicDeviceSensorDataReducer = (
    store: PublicDeviceSensorDataStore = initialStore,
    action: PublicDeviceAction = emptyAction
): PublicDeviceSensorDataStore => {
    switch (action.type) {
        case DeviceActionType.FetchDeviceSensorDataInit:
            return {
                ...store,
                loading: true,
            };
        case DeviceActionType.FetchDeviceSensorDataSuccess:
            return {
                ...store,
                loading: false,
                sensorData: action.response.sensorData,
                timeStamp: action.response.timeStamp,
            };
        case DeviceActionType.FetchDeviceSensorDataError:
            return {
                ...store,
                loading: false,
                error: true,
                errorMessage: action.error,
            };
        default:
            return {
                ...store,
            };
    }
};

export default publicDeviceSensorDataReducer;
